import { useEffect, useState } from "react";
import { api } from "@/lib/api";

function PageHeader({ title, count, subtitle }) {
  return (
    <div className="flex items-end justify-between mb-5">
      <div>
        <p className="text-[11px] uppercase tracking-widest text-slate-400 font-bold">{subtitle}</p>
        <h1 className="font-display font-bold text-3xl text-slate-900">{title}</h1>
      </div>
      {count !== undefined && (
        <span className="text-xs px-3 py-1.5 rounded-full bg-primary-50 text-primary-700 font-bold uppercase tracking-wider">{count} total</span>
      )}
    </div>
  );
}

export default function Employees() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/employees").then((r) => setItems(r.data || []));
  }, []);

  const filtered = items.filter(i => i.name?.toLowerCase().includes(search.toLowerCase()) || i.enec_id?.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <PageHeader title="Employees" subtitle="ENEC personnel" count={items.length} />
      <input
        data-testid="employees-search"
        placeholder="Search by name or ENEC ID…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="w-full max-w-md h-11 px-4 mb-4 rounded-xl border border-slate-200 bg-white outline-none focus:border-primary"
      />
      <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <table className="w-full">
          <thead className="bg-slate-50">
            <tr>
              {["Name", "ENEC ID", "Department", "Phone", "Email", "Status"].map(h => (
                <th key={h} className="text-left text-[11px] uppercase tracking-wider text-slate-500 font-bold px-5 py-3 border-b border-slate-200">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map(e => (
              <tr key={e.id} data-testid={`employee-row-${e.id}`} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="px-5 py-3 text-sm font-semibold text-slate-900 flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary to-primary-700 text-white flex items-center justify-center text-xs font-bold">
                    {e.name?.charAt(0)}
                  </div>
                  {e.name}
                </td>
                <td className="px-5 py-3 text-sm text-slate-700 font-mono">{e.enec_id}</td>
                <td className="px-5 py-3 text-sm text-slate-700">{e.department}</td>
                <td className="px-5 py-3 text-sm text-slate-700 font-mono">{e.phone}</td>
                <td className="px-5 py-3 text-sm text-slate-700">{e.email}</td>
                <td className="px-5 py-3"><span className="text-[10px] px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 font-bold uppercase tracking-wider">Active</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
